import plural from '../config/plural';

const getPluralName = (key) => {
  
  if (plural[key] && plural[key].plural) {
    return plural[key].plural;
  }

  return key;
}

export default getPluralName;